import React from "react";
import "./Products2.css";
import paintBlue from "../assets/paintblue4.png";
import paintBlueHover from "../assets/paintblue-hover.png";
import paintPink from "../assets/paintpink4.png";
import paintPinkHover from "../assets/paintpink-hover.png";
import paintNavy from "../assets/paintNavy4.png";
import paintNavyHover from "../assets/paintNavy-hover.png";
import paintCyan from "../assets/paintCyan4.png";
import paintCyanHover from "../assets/paintCyan-hover.png";
import paintRed from "../assets/paintRed4.png";
import paintRedHover from "../assets/paintRed-hover.png";
import paintYellow2 from "../assets/paintYellow4.png";
import paintYellowHover from "../assets/paintYellow-hover.png";
import paintGloss2 from "../assets/paintGloss4.png";
import paintGlossHover from "../assets/paintGloss-hover.png";

export default function Products2() {
  return (
    <section className="product2-section">
      <div className="product2-intro">
        <p>
          From rich, vibrant hues to subtle, sophisticated tones, Glamur Paint
          offers a diverse palette to suit every taste and project. Whether
          you’re refreshing a single wall or undertaking a complete renovation,
          our products provide exceptional coverage, smooth application, and
          long-lasting beauty. At Glamur Paint, we believe in the power of color
          to inspire and elevate. Join us in bringing your vision to life with
          paints that reflect the spirit and craftsmanship of Pakistan.
        </p>
        <button className="intro-btn">Browse Our Exclusive Shades</button>
      </div>

      <div className="product2-box">
        <h2 className="product2-title">Our Products</h2>

        <div className="product2-grid">
          {[
            {
              img: paintBlue,
              hover: paintBlueHover,
              name: "Plastic Emulsion",
              // price: "Rs 265 - Rs 3575",
            },
            {
              img: paintPink,
              hover: paintPinkHover,
              name: "Aquatic Matt Emulsion",
              // price: "Rs 265 - Rs 3575",
            },
            {
              img: paintNavy,
              hover: paintNavyHover,
              name: "Weather Guard",
              // price: "Rs 265 - Rs 3575",
            },
            {
              img: paintCyan,
              hover: paintCyanHover,
              name: "Aquatic Wall Sealer",
              // price: "Rs 265 - Rs 3575",
            },
          ].map((product, index) => (
            <div className="product2-card" key={index}>
              <div className="product2-image">
                <img src={product.img} alt={product.name} className="default" />
                <img src={product.hover} alt={product.name} className="hover" />
                {/* <img
                  src={selectIcon}
                  alt="select icon"
                  sizes="height:8px; width:8px;"
                  className="hover-icon"
                /> */}
              </div>
              <p className="product2-name">{product.name}</p>
              {/* <p className="product2-price">{product.price}</p> */}
            </div>
          ))}
        </div>

        {/* Second row - 3 items */}
        <div className="product2-grid second-row-grid">
          {[
            {
              img: paintRed,
              hover: paintRedHover,
              name: "High Class Emulsion",
              // price: "Rs 265 - Rs 3575",
            },
            {
              img: paintYellow2,
              hover: paintYellowHover,
              name: "Wall Putty",
              // price: "Rs 265 - Rs 3575",
            },
            {
              img: paintGloss2,
              hover: paintGlossHover,
              name: "Gloss Enamel",
              // price: "Rs 265 - Rs 3575",
            },
          ].map((product, index) => (
            <div className="product2-card" key={index + 4}>
              <div className="product2-image">
                <img src={product.img} alt={product.name} className="default" />
                <img src={product.hover} alt={product.name} className="hover" />
                {/* <img
                  src={selectIcon}
                  alt="select icon"
                  className="hover-icon"
                /> */}
              </div>
              <p className="product2-name">{product.name}</p>
              {/* <p className="product2-price">{product.price}</p> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
